import { useState } from "react";
import "./Payment.css";
import axios from "axios";

function Quotation({ quotations = [] }) {
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 10;

    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = quotations.slice(indexOfFirstLog, indexOfLastLog);

    const totalPages = Math.ceil(quotations.length / logsPerPage);

    const handleQuotationDownload = async (ID, type) => {
        try {
            const url =
                `${process.env.REACT_APP_BASEURL}/apis/vendor/quotation_download.php?` +
                `id=${encodeURIComponent(ID)}`;
            const response = await fetch(url, { method: "GET" });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            if (type === "view") {
                window.open(fileURL, "_blank");
            } else if (type === "download") {
                const a = document.createElement("a");
                a.href = fileURL;
                a.download = "quotation.pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
            window.URL.revokeObjectURL(fileURL);
        } catch (error) {
            console.error("Failed to fetch quotation:", error);
        }
    };

    return (
        <>
            <h1 className="dashboard-heading">Quotation</h1>
            <div className="payment-dashboard">
                <section className="payment-table-section">
                    <table className="payment-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Quotation No</th>
                                <th>User Name</th>
                                <th>Contact</th>
                                <th>Eamil</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentLogs.length > 0 ? (
                                currentLogs.map((quotation, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstLog + index + 1}</td>
                                        <td>{quotation.date}</td>
                                        <td>{quotation.quotationNumber}</td>
                                        <td>{quotation.Username}</td>
                                        <td>{quotation.Contact}</td>
                                        <td>{quotation.Email}</td>
                                        <td>
                                            <div >
                                                <button className="status pending" style={{ marginRight: "5px" }} onClick={() => handleQuotationDownload(quotation?.id, "view")}>View</button>
                                                <button className="status paid"  onClick={() => handleQuotationDownload(quotation?.id, "download")}>Download</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        No Quotation available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </section>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        >
                            ◀ Prev
                        </button>

                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={currentPage === i + 1 ? "active" : ""}
                                onClick={() => setCurrentPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        >
                            Next ▶
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

export default Quotation;
